import React from "react";
import { Button, Form, Input, Space, Typography } from "antd";
import { useAuth } from "../../Context/authContext";
import { useNavigate } from "react-router-dom";
import HeaderPage from "../../pages/HeaderPage";
const { Title } = Typography;

const SignUp: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = (values: any) => {
    login();
    navigate("/");
  };

  return (
    <div style={styles.container} className="auth-container">
      <Form
        onFinish={onFinish}
        style={styles.form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 24 }}
      >
        <HeaderPage />
        <br />
        <div style={{ marginLeft: "20px" }}>
          <Form.Item
            label="First Name"
            name="firstName"
            colon={false}
            // rules={[{ required: true, message: "Please enter your username" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="lastName"
            colon={false}
            // rules={[{ required: true, message: "Please enter your username" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Organization"
            name="organization"
            colon={false}
            // rules={[{ required: true, message: "Please enter your username" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            colon={false}
            // rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input type="email" />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Space>
              <Button type="primary" htmlType="submit">
                SUBMIT
              </Button>
              <Button
                style={{ fontSize: "16px", marginLeft: "20px", color: "#000" }}
                type="default"
              >
                CANCEL
              </Button>
            </Space>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "30px",
  },
  form: {
    width: "790px",
    height: "500px",
    padding: "50px",
    background: "rgba(0, 0, 0, 0.3)",

    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  heading: {
    textAlign: "center" as const,
    marginBottom: "20px",
    color: "#ffffff",
  },
};

export default SignUp;
